import { closeModal } from '@/store/actions';
import { Box, Divider, Modal, Theme, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { styles } from '../AppBar/CancelModal/styles';
import { palette } from '@/theme/constants';
import { MuiButton } from '../Button';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';

export const ErrorPopup = () => {
  const { open, content, hasLink, linkText, linkPath } = useSelector((state: any) => state.intermitence.modal);
  const dispatch = useDispatch();
  const router = useRouter();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const { t } = useTranslation();

  if (!open) return null;

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleLinkClick = () => {
    if (linkPath) {
      // Check if it's a mailto link or external link
      if (linkPath.startsWith('mailto:') || linkPath.startsWith('http')) {
        window.location.href = linkPath;
      } else {
        router.push(linkPath);
      }
      dispatch(closeModal());
    }
  };

  const renderContent = () => {
    if (hasLink && linkText && content) {
      // Split content around the link text
      const parts = content.split(linkText);
      if (parts.length === 2) {
        return (
          <>
            {parts[0]}
            <Typography
              component="span"
              sx={{
                color: palette.white,
                textDecoration: 'underline',
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.8,
                },
              }}
              onClick={handleLinkClick}
            >
              {linkText}
            </Typography>
            {parts[1]}
          </>
        );
      }
    }
    return t(`${content}`);
  };

  return (
    <Modal open={open} onClose={handleClose} sx={styles.modal}>
      <Box
        width={isMobile ? '90%' : '38.1875rem'}
        height={'100%'}
        minHeight={'10rem'}
        maxHeight={'11rem'}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        padding={isMobile ? '1rem' : '1.5rem'}
        borderRadius={'1.25rem'}
        justifyContent={'space-between'}
        position={'relative'}
        bgcolor={palette.cardBackground}
        sx={{ backdropFilter: 'blur(1.5625rem)' }}
        border={`0.063rem solid ${palette.cardBorder}`}>
        <Typography variant='body1' mt={isMobile ? '0' : '2'} sx={{ fontWeight: 'bold', textAlign: 'center', whiteSpace: 'pre-line' }}>
          {renderContent()}
        </Typography>
        <Divider sx={{ backgroundColor: palette.dirtyWhite, my: 2, width: '100%' }} />
        <Box display='flex' justifyContent='center' width='100%'>
          <Box>
            <MuiButton type='button' loading={false} variant={'outlined'} method={handleClose}>
              <Typography variant='button' color={palette.white}>
                Close
              </Typography>
            </MuiButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
